'use client';

import styles from './EcItemPurchaseButton.module.scss';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  color?: string;
  bgColor?: string;
  outlined?: boolean;
};

function EcItemPurchaseButton({
  children,
  onClick,
  disabled = false,
  color = 'white',
  bgColor = 'black',
  outlined = false,
}: Props) {
  return (
    <button
      className={styles.actionButton}
      type='button'
      onClick={onClick}
      style={generateStyle({ color, bgColor, outlined })}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

const generateStyle = ({
  color,
  bgColor,
  outlined,
}: Pick<Props, 'color' | 'bgColor' | 'outlined'>): React.CSSProperties => {
  if (outlined) {
    return {
      color: `var(--color-${color})`,
      border: `3px solid var(--color-${color})`,
      background: `var(--color-${bgColor})`,
    };
  }

  // 背景色に応じてグラデーション
  switch (bgColor) {
    case 'primary':
      return {
        border: 'none',
        background: 'linear-gradient(to top, #e11111, var(--color-primary))',
      };
    default:
      return {
        border: `var(--color-${color})`,
        background: `var(--color-${bgColor})`,
      };
  }
};
export default EcItemPurchaseButton;
